import { render, staticRenderFns } from "./Resistance.vue?vue&type=template&id=74cdcbbd&scoped=true"
import script from "./Resistance.vue?vue&type=script&lang=js"
export * from "./Resistance.vue?vue&type=script&lang=js"
import style0 from "./Resistance.vue?vue&type=style&index=0&id=74cdcbbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cdcbbd",
  null
  
)

export default component.exports